const initCopyPassword = () => {
  const passwordEl = document.getElementById('copy-password');

  if (!passwordEl) return;

  passwordEl.addEventListener('click', async function () {
    const text = passwordEl.textContent.trim();
    let copied = false;

    // Try modern clipboard API first
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        copied = true;
      } catch (err) {
        console.error('navigator.clipboard failed:', err);
      }
    }

    // Fallback
    if (!copied) {
      copied = fallbackCopy(text);
    }

    if (copied) {
      showCopyFeedback(passwordEl, 'Copied!');
    } else {
      showCopyFeedback(passwordEl, 'Copy failed');
      console.error('Copy failed completely');
    }
  });

  function showCopyFeedback(el, message) {
    const existing = el.querySelector('.copy-tooltip');
    if (existing) existing.remove();

    const tooltip = document.createElement('span');
    tooltip.className = 'copy-tooltip';
    tooltip.textContent = message;
    tooltip.style.position = 'absolute';
    tooltip.style.background = '#000';
    tooltip.style.color = '#fff';
    tooltip.style.padding = '4px 8px';
    tooltip.style.fontSize = '12px';
    tooltip.style.borderRadius = '4px';
    tooltip.style.top = '-30px';
    tooltip.style.left = '0';
    tooltip.style.whiteSpace = 'nowrap';

    el.style.position = 'relative';
    el.appendChild(tooltip);

    setTimeout(() => tooltip.remove(), 1500);
  }

  function fallbackCopy(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '-9999px';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, text.length);

    let success = false;

    try {
      success = document.execCommand('copy');
      console.log('execCommand copy success:', success);
    } catch (err) {
      console.error('execCommand failed:', err);
    }

    document.body.removeChild(textarea);
    return success;
  }
};

export default initCopyPassword;